var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuditories(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.0003,
    height: 28.0003,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 26.0003H2V2.00034H10V8.00034C10.0016 8.53029 10.2128 9.03808 10.5875 9.41281C10.9623 9.78754 11.4701 9.99876 12 10.0003H18V16H19.9268L20 8.00034C20.0035 7.86892 19.9785 7.73829 19.9268 7.61745C19.875 7.49661 19.7976 7.38842 19.7 7.30034L12.7 0.30034C12.612 0.202685 12.5038 0.12529 12.3829 0.0734971C12.2621 0.0217038 12.1314 -0.00325583 12 0.00034004H2C1.47005 0.00192277 0.962265 0.213145 0.587535 0.587875C0.212805 0.962605 0.00158273 1.47039 0 2.00034V26.0003C0.00158273 26.5303 0.212805 27.0381 0.587535 27.4128C0.962265 27.7875 1.47005 27.9988 2 28.0003L8 28V26.0003ZM12 2.40034L17.6 8.00034H12V2.40034Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.8125H19L15.7857 18M19 24.1875H10L13.2143 27",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditories);
export default __webpack_public_path__ + "static/media/auditories.2a09c5516d804146da6fc3b509bfd18a.svg";
export { ForwardRef as ReactComponent };